import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { useApi } from "@/lib/api";

export function PaymentSuccess() {
  const api = useApi();
  const { loadMe } = useApp();
  const [params] = useSearchParams();
  const [state, setState] = useState("checking");

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) {
      setState("failed");
      return undefined;
    }
    let tries = 0;
    let timer;
    const poll = async () => {
      tries += 1;
      try {
        const r = await api.get(`/payments/status/${sid}`);
        if (r.data.payment_status === "paid" || r.data.status === "completed") {
          setState("paid");
          await loadMe();
          return;
        }
        if (["expired", "failed"].includes(r.data.payment_status)) {
          setState("failed");
          return;
        }
      } catch (e) {
        // keep polling
      }
      if (tries < 15) timer = setTimeout(poll, 2000);
      else setState("timeout");
    };
    poll();
    return () => clearTimeout(timer);
  }, [api, params, loadMe]);

  const msg = {
    checking: ["Confirming your payment…", "This only takes a moment."],
    paid: ["Subscription active", "Uploads and edits are switched on for your firm."],
    failed: ["Payment not completed", "No charge was made. You can try again from Billing."],
    timeout: ["Still confirming", "Your payment is processing. Refresh Billing in a minute."],
  }[state];
  const Icon = state === "paid" ? CheckCircle2 : state === "checking" ? Loader2 : XCircle;
  return (
    <div className="panel p-10 max-w-xl" data-testid="payment-result">
      <Icon className={`h-8 w-8 ${state === "paid" ? "text-emerald-700" : state === "checking" ? "animate-spin text-slate-400" : "text-amber-700"}`} />
      <h1 className="font-serif text-4xl mt-5" data-testid="payment-result-title">{msg[0]}</h1>
      <p className="text-slate-600 mt-3">{msg[1]}</p>
      <Link to="/billing" className="inline-block mt-8 bg-slate-900 text-white px-6 py-3 text-sm hover:bg-slate-800 transition-colors duration-200" data-testid="payment-result-billing">Back to billing</Link>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="panel p-10 max-w-xl" data-testid="payment-cancel">
      <h1 className="font-serif text-4xl">Checkout cancelled</h1>
      <p className="text-slate-600 mt-3">No charge was made.</p>
      <Link to="/billing" className="inline-block mt-8 bg-slate-900 text-white px-6 py-3 text-sm hover:bg-slate-800 transition-colors duration-200" data-testid="payment-cancel-billing">Back to billing</Link>
    </div>
  );
}
